<template>
  <img
    v-if="photoUrl && !loadFailed"
    class="review-avatar review-avatar--img"
    :src="photoUrl"
    :alt="name"
    referrerpolicy="no-referrer"
    loading="lazy"
    decoding="async"
    @error="loadFailed = true"
  />
  <img
    v-else-if="isGoogleUser"
    class="review-avatar review-avatar--google"
    :src="googleLogo"
    :alt="name"
    loading="lazy"
    decoding="async"
  />
  <span v-else class="review-avatar" :style="background ? { background } : null">{{ initials }}</span>
</template>

<script>
export default {
  props: {
    name: { type: String, default: "" },
    photoUrl: { type: String, default: null },
    background: { type: String, default: "" },
    maxInitials: { type: Number, default: 2 },
    isGoogleUser: { type: Boolean, default: false },
  },
  data() {
    return {
      loadFailed: false,
    };
  },
  computed: {
    googleLogo() {
      return require("@assets/images/widget/google/google.svg");
    },
    initials() {
      return (this.name || "")
        .split(" ")
        .filter(Boolean)
        .slice(0, this.maxInitials)
        .map((w) => w[0])
        .join("")
        .toUpperCase();
    },
  },
  watch: {
    photoUrl() {
      this.loadFailed = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.review-avatar {
  width: var(--review-avatar-size, 40px);
  height: var(--review-avatar-size, 40px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--review-avatar-fs, 14px);
  font-weight: 600;
  flex-shrink: 0;
  background: var(--review-avatar-bg, #e8f0fe);
  color: var(--review-avatar-color, #1a73e8);

  &--img {
    object-fit: cover;
  }
  &--google {
    box-sizing: border-box;
    object-fit: contain;
    padding: calc(var(--review-avatar-size, 40px) * 0.18);
    background: #ffffff;
    border: 1px solid #dadce0;
  }
}
</style>
